import attachmentApi from "app/services/http-services/attachment/attachment-api";
import queryKeys from "shared/services/queryKeys";
import { PlatformThemeMode } from "app/theme/platformTheme";

export const themeQueryKey = queryKeys.records.config("sys_themes", { active: true });
export const DEFAULT_LOGO_MARK_URL = "/img/prm-logo-color.svg";
export const DEFAULT_LOGO_WORDMARK_URL = "/img/primum-logo-text.png";
export const defaultWordmarkUrl = (mode: PlatformThemeMode) =>
    mode === "dark" ? "/img/primum-logo-text-light.png" : DEFAULT_LOGO_WORDMARK_URL;

type ThemeLogoApi = Pick<typeof attachmentApi, "listAttachments" | "downloadAttachmentUrl">;

export const resolveThemeLogos = async (
    themeId: string,
    showLogoWordmark: boolean,
    api: ThemeLogoApi,
    mode: PlatformThemeMode = "light"
): Promise<{ logoMarkUrl: string; logoWordmarkUrl: string | null }> => {
    const listColumn = (column: "logo_mark" | "logo_wordmark") =>
        api.listAttachments("sys_themes", themeId, column).catch(() => []);

    const [marks, wordmarks] = await Promise.all([
        listColumn("logo_mark"),
        showLogoWordmark ? listColumn("logo_wordmark") : Promise.resolve([]),
    ]);

    return {
        logoMarkUrl: marks[0]
            ? api.downloadAttachmentUrl("sys_themes", themeId, marks[0].id, "logo_mark")
            : DEFAULT_LOGO_MARK_URL,
        logoWordmarkUrl: !showLogoWordmark
            ? null
            : wordmarks[0]
                ? api.downloadAttachmentUrl("sys_themes", themeId, wordmarks[0].id, "logo_wordmark")
                : defaultWordmarkUrl(mode),
    };
};
